import React from 'react';
export const ProblemSection: React.FC = () => {
  const problems = ['No sabés si lo que te ofrecen es oro real o enchapado', 'No tenés idea de cómo calcular cuánto vale una pieza', 'No sabés dónde comprar barato ni dónde vender bien', 'Te da miedo que te estafen en la primera operación', 'Pensás que necesitás mucho capital para arrancar', 'No sabés qué herramientas necesitás ni cuánto cuestan', 'No sabés cómo negociar sin quedar como improvisado'];
  return <section className="py-20" style={{
    background: 'var(--bg-card)'
  }} data-id="element-130">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-131">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-4 leading-tight" data-id="element-132">
          Si alguna vez pensaste en{' '}
          <span style={{
          color: 'var(--gold)'
        }} data-id="element-133">
            ganar plata con oro
          </span>
          ,<br className="hidden sm:block" data-id="element-134" />
          seguro te pasó:
        </h2>
        <p className="text-center text-lg mb-10 max-w-2xl mx-auto" style={{
        color: 'var(--text-secondary)'
      }} data-id="element-135">
          No es que no te interese. Es que nadie te explicó bien cómo funciona.
          Y la información suelta que encontrás online te deja con más dudas que
          respuestas.
        </p>

        <ul className="max-w-2xl mx-auto" data-id="element-136">
          {problems.map((problem, index) => <li key={index} className="py-3.5 pl-8 relative text-base" style={{
          color: 'var(--text-secondary)',
          borderBottom: index < problems.length - 1 ? '1px solid var(--border-subtle)' : 'none'
        }} data-id="element-137">
              <span className="absolute left-0 font-bold text-lg" style={{
            color: 'var(--red-alert)'
          }} data-id="element-138">
                ✗
              </span>
              {problem}
            </li>)}
        </ul>

        <div className="mt-10 border-l-3 pl-6 max-w-2xl mx-auto italic text-lg leading-relaxed" style={{
        borderLeftWidth: '3px',
        borderLeftColor: 'var(--gold)',
        color: 'var(--text-secondary)'
      }} data-id="element-139">
          "Miles de personas venden oro sin saber lo que tienen. La diferencia
          entre vos y ellos es que vos vas a saber cuánto vale antes de
          comprar."
        </div>
      </div>
    </section>;
};